'use client';
import apiClient from './apiClient';

/** 會員相關 */
class UserClient {
    // 取得 user 成就
    getUserAchievement = () => apiClient.get('/member/achievement');
}

const userClient = new UserClient();

export default userClient;
